import axios from "axios"
//import https from "@/https"
import querystring from "querystring"
import Vue from "vue";
//import emitter from "./eventBus";
import errorHandler from "./errorHandler";

// const netErrorHandle = (status:Number,info:string) => {
//     let errorMessage = '';
//     switch(status){
//         case 400:
//             errorMessage = "语义有误";
//             break;
//         case 401:
//             errorMessage = "服务器认证失败";
//             break;
//         case 403:
//             errorMessage = "服务器拒绝访问";
//             break;
//         case 404:
//             errorMessage = "地址错误";
//             break;
//         case 500:
//             errorMessage = "服务器遇到意外";
//             break;
//         case 502:
//             errorMessage = "服务器无响应";
//             break;
//         default:
//             //errorMessage = info;
//             errorMessage = "未知错误";
//             break;
//     }
//     // 使用事件总线触发一个事件，并传递错误信息
//     const fullMessage = `${errorMessage}\n错误码:${status}`;
//     emitter.emit('show-error-toast', fullMessage);
// }

//axios.defaults.headers.post['Content-Type'] = 'application/json;text/plain;charset=UTF-8';


const instance = axios.create(
    {
    // 网络请求的公共配置
    timeout:50000,
    baseURL:'/zwai'
 })

// 拦截器最常用的

// 发送数据之前
instance.interceptors.request.use(
    config =>{
        // //debugger
        // if(config.method === "post"){
        //     config.data = querystring.stringify(config.data)
        // }
        // config:包含着网络请求的所有信息
        return config;
    },
    error =>{
        return Promise.reject(error)
    }
)

// 获取数据之前
instance.interceptors.response.use(
    response =>{
        //debugger
        return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
    },
    error =>{
        
        const { response } = error;
        // 错误的处理才是我们需要最关注的
        if(undefined != response)
        {
            errorHandler(response.status,response.info);
        }
        else
        {
            errorHandler(0,error.message);
        }
    }
)

export default instance;